import React, { useState, useEffect } from "react";

import { useUser } from "./services/firebaseAuth";
import { OrderContext, UserContext } from "./context";
import { isDev } from "./helpers";

export const initUser = { isSignedIn: false, favorite: [] };

export default (props) => {
  const [orders, setOrders] = useState([]);
  if (isDev) {
    console.log("render context provider");
    console.log("Order state", orders);
  }

  const [user, setUser] = useUser();

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {isDev ? console.log(user) : null}
      <OrderContext.Provider value={{ orders, setOrders }}>
        {props.children}
      </OrderContext.Provider>
    </UserContext.Provider>
  );
};
